module.exports = __webpack_public_path__ + "img/rule_tab1.7525cfa2.png";